export const tipoVeiculoOpcoesFipe = [
  { fipe: "cars", label: "Carro", marcas: null },
  { fipe: "trucks", label: "Caminhão", marcas: null },
  { fipe: "motorcycles", label: "Motocicleta", marcas: null },
];

export const tipoVeiculoFipeOptions = [
  { value: "Carro", label: "Carro" },
  { value: "Caminhão", label: "Caminhão" },
  { value: "Motocicleta", label: "Motocicleta" },
];
